import { getMaster } from "utils/api";

export const fetchStatistics = async () => {
  return await getMaster("/stats/merchants?service=online");
};
